<script>
import offerModal from "../offers/OfferModal.vue";
import pdfUtility from "../utility/pdfUtility";
import excelUtility from "../utility/excelUtility";
import offeruploadexcel from "@/components/offers/offeruploadexcel";

export default {
  name: "offer-table",
  components: { offerModal, pdfUtility, excelUtility, offeruploadexcel },
  data: function() {
    return {
      loading: false,
      page: 1,
      filter: "",
      offers: [],
      totalItemCount: 0,
      activeItem: "",
      headers: [
        { text: "Vessel", value: "VesselVesselName" },
        { text: "Period", value: "OfferPeriods" },
        { text: "Delivery Date", value: "DeliveryWindow" },
        { text: "Duty", value: "Duty" },
        { text: "Day Rate", value: "DailyRateDisplay" },
        { text: "Other Costs", value: "OtherCostsDisplay" },
        { text: "Delivery", value: "DeliveryLocations" },
        { text: "Redelivery", value: "RedeliveryLocations" },
        { text: "Status", value: "StatusDisplay" },
        { text: "Modified", value: "LastModified" },
        { text: "", value: "actions" },
      ],
      selectedOfferId: null,
      dialogDelete: false,
      allCurrencies: [],
    };
  },
  methods: {
    async getData() {
      this.loading = true;

      this.offers = await this.$store.dispatch("getRequest", {
        controller: "ProjectsApi",
        method: "GetOffersSummary",
        parameters: { id: this.activeRequirementId },
      });
      this.loading = false;
    },
    onRowEdit: function(item) {
      this.$store.commit("setActiveOfferModal", { visible: true, id: item.OfferId });
    },
    onDeleteItem(item) {
      this.selectedOfferId = item.OfferId;
      this.dialogDelete = true;
    },
    onCloseDelete() {
      this.dialogDelete = false;
      this.selectedOfferId = null;
    },
    async onConfirmRowDelete() {
      await this.$store.dispatch("getRequest", {
        controller: "ProjectsApi",
        method: "DeleteOffer",
        parameters: { id: this.selectedOfferId },
      });
      this.onCloseDelete();
    },
    onRowClick(item) {
      this.selectedOfferId = item.OfferId;
    },
    onAddNew() {
      this.$store.commit("setActiveOfferModal", { visible: true, id: null });
    },
    groupCostBreakDownItemsByCategory(items) {
      var result = [];
      for (var i = 0; i < items.length; i++) {
        var exist = result.filter(function(x) {
          return x.category == items[i].Category;
        })[0];

        if (exist) {
          exist.items.push(items[i]);
        } else {
          result.push({ category: items[i].Category, items: [items[i]] });
        }
      }
      return result;
    },
    async getCurrencies() {
      this.allCurrencies = await this.$store.dispatch("getRequest", { controller: "lookup", method: `GetCurrencyTypesShort` });
    },
    exportToPdf(id) {
      this.$refs.pdf.createOfferPdf(id);
    },
    importExcelFile(id) {
      this.$refs.offeruploadexcel.Show(id);
    },
    exportToExcel(id) {
      this.$refs.excel.createOfferExcel(id);
    },
    async sendAsEmail(id) {
      var result = await this.$store.dispatch("getRequest", {
        controller: "ProjectsApi",
        method: "SendOfferEmail",
        parameters: { id: id },
      });
      this.$store.commit("setMessage", { title: "Success", type: "info", content: `Please check your email inbox` });
    },
  },
  computed: {
    isMobile: function() {
      return this.$store.state.isMobile;
    },
    editModalVisible() {
      return this.$store.state.offerModal && this.$store.state.offerModal.visible;
    },
    activeRequirementId: function() {
      return this.$store.state.activeRequirementId;
    },
  },
  async mounted() {
    await this.getCurrencies();
  },
  watch: {
    dialogDelete: function() {
      this.getData();
    },
    editModalVisible: {
      deep: true,
      handler() {
        this.getData();
      },
    },
    activeRequirementId() {
      this.getData();
    },
  },
};
</script>
<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-btn :disabled="!activeRequirementId" rounded v-on:click="onAddNew()">Add Offer<i class="fas fa-plus-circle icon-right"></i></v-btn>
        <v-text-field
          :disabled="!activeRequirementId"
          style="float:right"
          hide-details="auto"
          dense
          class="pa-0"
          v-model="filter"
          append-icon="mdi-magnify"
          :label="`Search Offers`"
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      dense
      v-on:click:row="onRowClick"
      :headers="headers"
      :items="offers"
      class="elevation-1"
      :search="filter"
      :loading="loading"
      :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
      loading-text="Loading... Please wait"
      :no-data-text="activeRequirementId ? 'No offers to show - Click above to add' : 'Select a Requirement from above to see related offers'"
    >
      <template slot="item" scope="props"
        ><tr v-on:click="onRowClick(props.item, props.index)">
          <td
            v-for="(columnHeader, columnIndex) in headers"
            :key="`${columnIndex}-${props.item.id}-vessel-source`"
            :class="`text-${columnHeader.align}`"
          >
            <v-chip v-if="columnHeader.chip" :color="columnHeader.chipColors[props.item[columnHeader.value]]"
              ><span class="white--text">{{ props.item[columnHeader.value] }}</span></v-chip
            >
            <span v-else-if="columnHeader.type == 'date'">
              {{ formatDate(props.item[columnHeader.value], true, false) }}
            </span>
            <v-menu top offset-y v-else-if="columnHeader.value == 'actions'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on">
                  <v-icon>
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="onRowEdit(props.item)">
                  <v-list-item-icon>
                    <v-icon class="mr-2">
                      mdi-pencil
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item>
                <v-list-item @click="sendAsEmail(props.item.OfferId)">
                  <v-list-item-icon>
                    <v-icon>
                      mdi-email-send
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Email</v-list-item-title>
                </v-list-item>
                <v-list-item @click="exportToExcel(props.item.OfferId)">
                  <v-list-item-icon>
                    <v-icon>
                      mdi-file-excel
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Export to excel</v-list-item-title>
                </v-list-item>
                <v-list-item @click="importExcelFile(props.item.OfferId)">
                  <v-list-item-icon>
                    <v-icon class="mr-2">
                      mdi-file-pdf
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Import Excel response</v-list-item-title>
                </v-list-item>
                <v-list-item @click="exportToPdf(props.item.OfferId)">
                  <v-list-item-icon>
                    <v-icon class="mr-2">
                      mdi-file-pdf
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Export Pdf</v-list-item-title>
                </v-list-item>
                <v-list-item @click="onDeleteItem(props.item)">
                  <v-list-item-icon>
                    <v-icon>
                      mdi-delete
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <span v-else>
              {{ props.item[columnHeader.value] }}
            </span>
          </td>
        </tr></template
      >
    </v-data-table>
    <offeruploadexcel ref="offeruploadexcel"></offeruploadexcel>
    <offer-modal ref="offermodal"></offer-modal>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text class="subtitle-1 pt-3 text-center"
          >Are you sure you want to permanently delete this offer? This action cannot be undone.</v-card-text
        >
        <v-card-actions>
          <v-btn @click="onCloseDelete">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="onConfirmRowDelete">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <pdf-utility ref="pdf"></pdf-utility>
    <excel-utility ref="excel"></excel-utility>
  </div>
</template>
<style scoped>
[class*="status"] {
  font-size: 12px;
}
.table.mobile {
  font-size: 12px;
}
</style>
